import React from 'react';
import { MainView, NoAccessView } from '@repo/ui/Views';
import CampaignView from '../components/CampaignView';

import { useQuery } from '@apollo/client/react';
import CAMPAIGN_SHOW_Q from '../gql/campaignShow.gql';

import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';

const Campaign = () => {
  const params = useParams();
  const campaignId = params.campaignId;

  const { loading, data, error } = useQuery(CAMPAIGN_SHOW_Q, {
    variables: {
      id: String(campaignId),
    },
  });

  const user = useUser();

  return POLICIES['csp_campaigns:show'](user) ? (
    <MainView
      title={loading ? `Loading...` : `Campaign ID: ${data?.cspCampaign.tcr_campaign_id}`}
      loading={loading}
    >
      <CampaignView data={data} loading={loading} error={error} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Campaign;
